<base-section [index]="index" [section]="section">
  <div class="grid grid-section flex items-start">
    <div class="content flex-1" *ngIf="sectionRendered.introduction || sectionRendered.title">
      <h2 class=".h2" [innerHTML]="sectionRendered.title"></h2>
      <div class="introduction" [innerHTML]="sectionRendered.introduction| safeHtml"></div>
    </div>
    <a class="button" *ngIf="sectionRendered.url" [routerLink]="[sectionRendered.url]">Tout voir</a>
  </div>
  <div class="grid grid-section md-grid-cols-{{sectionRendered.columns}} gap-l mt-3 list-links-container">
    <ng-container *ngFor="let link of sectionRendered.links">
      <tiny-post class="col-1" [title]="link.title" *ngIf="link.page" [post]="link.page|tinyPostFromId|async"></tiny-post>
      <a [routerLink]="[link.link]" [relativeTo]="null" data-aos="fade-up" data-aos-once="true" data-aos-duration="1000" [fragment]="link.fragment" class="visual-link" *ngIf="!link.page && !link.external && link.link && link.image">
        <media-attachment
          [sizeXL]="sizeXL"
          [sizeLG]="sizeLG"
          [sizeMD]="sizeMD"
          [sizeSM]="sizeSM"
          [sizeXS]="sizeXS"
          [attachment]="link.image|attachmentFromId|async"
        ></media-attachment>
        <div class="title" [innerHTML]="link.title"></div>
      </a>
      <a href="{{link.link}}" target="_blank" data-aos="fade-up" data-aos-duration="1000" data-aos-once="true" class="visual-link" *ngIf="!link.page && link.external && link.link && link.image">
        <media-attachment
          [sizeXL]="sizeXL"
          [sizeLG]="sizeLG"
          [sizeMD]="sizeMD"
          [sizeSM]="sizeSM"
          [sizeXS]="sizeXS"
          [attachment]="link.image|attachmentFromId|async"
        ></media-attachment>
        <div class="title" [innerHTML]="link.title"></div>
      </a>
    </ng-container>
  </div>
</base-section>
